import "./ProductTable.scss";
import inventory from "./inventorydata3.json";
import * as React from "react";
import { useTable } from "react-table";
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function ProductTable() {
  const data = React.useMemo(() => inventory, []);
  const columns = React.useMemo(
    () => [
      {
        Header: <TranslateText text="Date Opened (History)" />,
        accessor: "Date Opened (History)",
      },
      {
        Header: <TranslateText text="Name of Bank" />,
        accessor: "Name of Bank",
      },
      {
        Header: <TranslateText text="Credit Limit" />,
        accessor: "Credit Limit",
      },
      {
        Header: <TranslateText text="Estimated Report Date" />,
        accessor: "Estimated Report Date",
      },
      {
        Header: <TranslateText text="Price" />,
        accessor: "Price",
      },
      {
        Header: <TranslateText text="Available Slots" />,
        accessor: "Available Slots",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

  return (
    <div className="ProductTable">
      <div className="boost-container3">
        <span className="large-text4">
          <TranslateText text="Tradeline Inventory" />
        </span>
        <div className="separator2"></div>
        <br />
        <span className="large-text8">
          <TranslateText text="**Please Note: Tradelines slots can fill up extremely fast!! We will confirm availability with you." />
        </span>
        <div className="container">
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.id}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} key={cell.id}>
                        {cell.column.id === 'id' ? (
                          <img 
                            src={require(`assets/img/${cell.value}`)} 
                            alt="Name of Bank" 
                            style={{ width: '75px', height: '75px', objectFit: 'contain' }} 
                          />
                        ) : (
                          cell.render('Cell')
                        )}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProductTable;


// import "./ProductTable.scss";
// import inventory from "./inventorydata3.json";
// import * as React from "react";
// import { useTable } from "react-table";
// import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

// function ProductTable() {
//   const data = React.useMemo(() => inventory, []);
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: <TranslateText text="Date Opened (History)" />,
//         accessor: "Date Opened (History)",
//       },
//       {
//         Header: <TranslateText text="Name of Bank" />,
//         accessor: "Name of Bank",
//       },
//       {
//         Header: <TranslateText text="Credit Limit" />,
//         accessor: "Credit Limit",
//       },
//       {
//         Header: <TranslateText text="Estimated Report Date" />,
//         accessor: "Estimated Report Date",
//       },
//       {
//         Header: <TranslateText text="Price" />,
//         accessor: "Price",
//       },
//       {
//         Header: <TranslateText text="Available Slots" />,
//         accessor: "Available Slots",
//       },
//     ],
//     []
//   );

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

//   return (
//     <div className="ProductTable">
//       <div className="boost-container3">
//         <span className="large-text4">Tradeline Inventory</span>
//         <div className="separator2"></div>
//         <br />
//         <span className="large-text8">
//           **Please Note: Tradelines slots can fill up extremely fast!! We will confirm availability with you.
//         </span>
//         <div className="container">
//           <table {...getTableProps()}>
//             <thead>
//               {headerGroups.map((headerGroup) => (
//                 <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
//                   {headerGroup.headers.map((column) => (
//                     <th {...column.getHeaderProps()} key={column.id}>
//                       {column.render('Header')}
//                     </th>
//                   ))}
//                 </tr>
//               ))}
//             </thead>
//             <tbody {...getTableBodyProps()}>
//               {rows.map((row) => {
//                 prepareRow(row);
//                 return (
//                   <tr {...row.getRowProps()} key={row.id}>
//                     {row.cells.map((cell) => (
//                       <td {...cell.getCellProps()} key={cell.id}>
//                         {cell.column.id === 'id' ? (
//                           <img 
//                             src={require(`assets/img/${cell.value}`)} 
//                             alt="Name of Bank" 
//                             style={{ width: '75px', height: '75px', objectFit: 'contain' }} 
//                           />
//                         ) : (
//                           cell.render('Cell')
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProductTable;



// import "./ProductTable.scss";
// import inventory from "./inventorydata3.json";
// import * as React from "react";
// import { useTable } from "react-table";



// function ProductTable() {
//   const data = React.useMemo(() => inventory, []);
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: "Date Opened (History)",
//         accessor: "Date Opened (History)",
//       },
//       {
//         Header:  "Name of Bank",
//         accessor: "Name of Bank",
//       },
//       {
//         Header: "Credit Limit",
//         accessor: "Credit Limit",
//       },
//       {
//         Header: "Estimated Report Date",
//         accessor: "Estimated Report Date",
//       },
//       {
//         Header: "Price",
//         accessor: "Price",
//       },
//       {
//         Header: "Available Slots",
//         accessor: "Available Slots",
//       },
    
//     ],
//     []
//   );

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
//     useTable({ columns, data });
//     const ProductTable = ({ getTableProps, getTableBodyProps, headerGroups, rows, prepareRow }) =>  {}
//     return (
   
//       <div className="ProductTable">
//     <div className="boost-container3">
//     <span className="large-text4"> Tradeline Inventory</span>
//     <div className="separator2"></div>
//     <br></br>
//     <span className="large-text8">**Please Note: Tradelines slots can fill up extremely fast!! We will confirm availability with you.</span>
//         <div className="container">
//           <table {...getTableProps()}>
//             <thead>
//               {headerGroups.map((headerGroup) => (
//                 <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
//                   {headerGroup.headers.map((column) => (
//                     <th {...column.getHeaderProps()} key={column.id}>
//                       {column.render('Header')}
//                     </th>
//                   ))}
//                 </tr>
//               ))}
//             </thead>
//             <tbody>
//               {rows.map((row) => {
//                 prepareRow(row);
//                 return (
//                   <tr {...row.getRowProps()} key={row.id}>
//                     {row.cells.map((cell) => (
//                       <td {...cell.getCellProps()} key={cell.id}>
//                         {cell.column.id === 'id' ? (
//                           <img src={require(`assets/img/${cell.value}`)} alt="Name of Bank" 
//                           style={{ width: '75px', height: '75px', objectFit: 'contain' }}
//                           /> // Assuming cell.value is the path
                          
//                         ) : (
//                           cell.render('Cell')
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       </div>
//     );
//   };
  
//   export default ProductTable;
